import React, { useState, useRef, useEffect } from "react";
import "./Navbar.css";
import { NavLink, Link, useNavigate, useLocation } from "react-router-dom";
import { Clock, LayoutDashboard } from "lucide-react";
import { Icon } from "@iconify/react";
import { LightDark } from "../../Assets/CSS/Text";
import toast from "react-hot-toast";
import { jwtDecode } from "jwt-decode";

// const getUserRole = () => {
//   const roles = localStorage.getItem("roles");
//   return roles ? roles.split(",") : [];
// };

export const getUserRole = (token) => {
  try {
    const decoded = jwtDecode(token);
    console.log("Decoded JWT:", decoded);

    const roles = decoded.roles || []; // roles array from token
    const employeeFullName = decoded.employeeFullName || decoded.sub || null; // subject claim
    console.log(".................", employeeFullName);
    // Expiration (exp is in seconds, convert to ms)
    const expiryTime = decoded.exp ? decoded.exp * 1000 : null;

    return { roles, employeeFullName, expiryTime };
  } catch (error) {
    console.error("Invalid token", error);
    return { roles: [], userName: null, expiryTime: null };
  }
};
const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [navOpenDropdown, setNavOpenDropdown] = useState(null);
  const dropdownRef = useRef(null);
  const token = localStorage.getItem("token");
  const { roles = [], employeeFullName } = getUserRole(token);
  const [showLogoutPrompt, setShowLogoutPrompt] = useState(false);
  const [logoutLoading, setLogoutLoading] = useState(false);

  const toggleDropdown = () => {
    console.log("Dropdown clicked");
    setDropdownOpen((prev) => !prev);
  };

  const handleLogout = () => {
    setLogoutLoading(true); // show spinner

    localStorage.clear();
    toast.success("Logout Successfully");
    setTimeout(() => {
      navigate("/");
      setLogoutLoading(false); // in case you want to reuse the button later
    }, 1000);
    // Add your logout logic here (e.g., redirect to login page)
  };
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const navMenus = [
    {
      label: "Dashboard",
      path:
        roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_SYSTEM_ADMIN") ||
        roles.includes("ROLE_HR") ||
        roles.includes("ROLE_MANAGER")
          ? "/admin-dashboard"
          : "/employee-dashboard",
      visible:
        roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_SYSTEM_ADMIN") ||
        roles.includes("ROLE_HR") ||
        roles.includes("ROLE_MANAGER") ||
        roles.includes("ROLE_EMP"),
    },
    {
      label: "My Team",
      visible:
        roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_MANAGER") ||
        roles.includes("ROLE_HR"),
      children: [
        { path: "/emp-management", label: "Employee Manager" },
        { path: "/admin-timesheet", label: "Employee's Timesheet" },
        { path: "/projectdashboard", label: "Project Tracking" },
      ],
    },
    {
      label: "Employee Management",
      visible:
        roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_MANAGER") ||
        roles.includes("ROLE_HR"),
      children: [
        { path: "/emp-onbaord", label: "Employee Onboarding" },
        { path: "/onboardAppoint-approve", label: "Appointment Status" },
        { path: "/off-boarding", label: "Offboarding" },
        { path: "/salary-annexure", label: "Salary Annexure" },
      ],
    },
    {
      label: "My Timesheet",
      path: "/timesheet",
      visible:
        roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_MANAGER") ||
        roles.includes("ROLE_EMP"),
    },
    {
      label: "Leave Management",
      path: "/leave-management",
      visible:
        roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_MANAGER") ||
        roles.includes("ROLE_EMP") ||
        roles.includes("ROLE_HR") ||
        roles.includes("ROLE_SYSTEM_ADMIN"),
    },
    {
      label: "Department & Role",
      path: "/deptrole",
      visible:
        roles.includes("ROLE_ADMIN") || roles.includes("ROLE_SYSTEM_ADMIN"),
    },
    {
      label: "Offboarding",
      path: "/off-boarding",
      visible:
        roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_MANAGER") ||
        roles.includes("ROLE_HR"),
    },
    {
      label: "Resume Parser",
      path: "/resume-parsur",
      visible: roles.includes("ROLE_ADMIN"),
    },
  ];

  const filteredMenus = navMenus.filter((item) => item.visible);
  const dedupedRoutes = Array.from(
    new Map(
      filteredMenus
        .flatMap((item) =>
          (item.children || []).length
            ? item.children
            : [{ path: item.path, label: item.label }],
        )
        .map((navItem) => [navItem.path, navItem]),
    ).values(),
  );

  const isMenuActive = (path) => {
    if (!path) return false;
    return location.pathname === path || location.pathname.startsWith(path);
  };

  const toggleNavDropdown = (index) => {
    setNavOpenDropdown((prev) => (prev === index ? null : index));
  };

  console.log("UserName", employeeFullName);

  return (
    <div className="">
      <nav className="navbar">
        <div className="navbar-left">
          {/* Hamburger icon for small screens */}
          <button className="menu-icon" onClick={toggleMenu}>
            <Icon icon="material-symbols:menu-rounded" width="22" height="22" />
          </button>
          <img
            src={require("../../Assets/Images/EMS-logo.png")}
            alt="Company Logo"
            className="navbar-logo"
          />
        </div>
        <div className="navbar-right">
          <div
            className={`profile-dropdown ${dropdownOpen ? "open" : ""}`}
            ref={dropdownRef}
            onClick={toggleDropdown}
          >
            {/* <img
            src={require("../../Assets/Images/man.png")}
            alt="User Profile"
            className="navbar-user-img"
          /> */}
            <div
              className="rounded-circle d-flex justify-content-center align-items-center"
              style={{
                width: "40px",
                height: "40px",
                fontSize: "12px",
                color: "#999",
                backgroundColor: "#F0F0F0",
                border: "1px solid #F0F0F0 ",
              }}
            >
              <Icon icon="proicons:person" className="fs-4 " style={{}} />
            </div>
            <span className="navbar-user-name">{employeeFullName}</span>
            <Icon icon="mdi:chevron-down" className="navbar-dropdown-icon" />

            {dropdownOpen && (
              <div className="dropdown-menu">
                <ul>
                  <li
                    onClick={() => {
                      navigate("/profile");
                    }}
                    className="text-decoration-none d-flex justify-content-evenly align-item-center"
                    style={LightDark}
                  >
                    <span
                      className="rounded-circle d-flex justify-content-center align-items-center"
                      style={{
                        width: "32px",
                        height: "32px",
                        fontSize: "12px",
                        color: "#999",
                        backgroundColor: "#F0F0F0",
                        border: "1px solid #F0F0F0 ",
                      }}
                    >
                      <Icon
                        icon="proicons:person"
                        className="fs-5 "
                        style={{ color: "#909090" }}
                      />
                    </span>
                    {/* <Icon icon="proicons:person" className="fs-4 " style={{ color: '#909090' }} /> */}
                    Profile
                  </li>
                  <li
                    onClick={() => setShowLogoutPrompt(true)}
                    className="fs-6 fw-normal d-flex justify-content-evenly align-item-center"
                    style={{ color: "#E00000" }}
                  >
                    <Icon icon="material-symbols:logout" className="fs-4" />
                    Logout
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
        {/* Sidebar drawer for mobile */}
        <div className={`mobile-sidebar ${menuOpen ? "open" : ""}`}>
          <div className="mobile-sidebar-header">Menu</div>
          <ul className="mobile-sidebar-list">
            {filteredMenus.map((menu, index) => {
              if (menu.children) {
                const isOpen = navOpenDropdown === index;

                return (
                  <li key={menu.label} className="mobile-nav-group">
                    <button
                      type="button"
                      className={`mobile-nav-parent ${menu.children.some((child) => isMenuActive(child.path)) ? "active" : ""}`}
                      onClick={() => toggleNavDropdown(index)}
                    >
                      <span>{menu.label}</span>
                      <Icon
                        icon={isOpen ? "mdi:chevron-up" : "mdi:chevron-down"}
                        className="mobile-nav-caret"
                      />
                    </button>

                    {isOpen && (
                      <ul className="mobile-nav-submenu">
                        {menu.children.map((child) => (
                          <li key={child.path}>
                            <NavLink
                              to={child.path}
                              className={({ isActive }) =>
                                `mobile-nav-link ${isActive || isMenuActive(child.path) ? "active" : ""}`
                              }
                              onClick={() => setMenuOpen(false)}
                            >
                              {child.label}
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              }

              return (
                <li key={menu.path}>
                  <NavLink
                    to={menu.path}
                    className={({ isActive }) =>
                      `mobile-nav-link ${isActive || isMenuActive(menu.path) ? "active" : ""}`
                    }
                    onClick={() => setMenuOpen(false)}
                  >
                    {menu.label}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </div>
        {/* overlay to close sidebar when clicking outside */}
        {menuOpen && <div className="overlay" onClick={toggleMenu}></div>}
      </nav>
      {showLogoutPrompt && (
        <div className="prompt-overlay">
          <div className="prompt-box">
            <div className="d-flex justify-content-center align-item-center">
              <div className="Loading-icon">
                <Icon
                  icon="mdi:logout"
                  className="fs-4"
                  style={{ color: "#E00000" }}
                />
              </div>
            </div>
            <h3 className="prompt-title">Confirm Logout</h3>
            <p>Are you sure you want to log out?</p>
            <div className="prompt-actions">
              <button
                onClick={() => setShowLogoutPrompt(false)}
                className="cancel-button"
              >
                Cancel
              </button>
              {/* <button onClick={handleLogout} className="confirm-button">
                Logout
              </button> */}
              <button
                onClick={handleLogout}
                className="confirm-button btn btn-danger"
                disabled={logoutLoading}
              >
                {logoutLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Logging out...
                  </>
                ) : (
                  "Logout"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
